module.exports = __webpack_public_path__ + "img/trash-outline-red.c96e5d9e.svg";